<template><UserAgreementEditorBase agreement-type="Exchange Student" /></template>
<script>
import UserAgreementEditorBase from '@/views/user/UserAgreementEditorBase'
export default { name: 'UserExchangeAgreement', components: { UserAgreementEditorBase } }
</script>
